import { Component, OnInit, AfterContentInit, ChangeDetectionStrategy } from '@angular/core';
import { AppGlobals } from '../../app.globals';
import { RouterModule } from '@angular/router';

import { 
    DxButtonModule, 
    DxDataGridModule,     
    DxFormModule,
    DxMenuModule,
    DxToolbarModule,
    DxTabPanelModule,
    DxRadioGroupModule,
    DxDrawerModule,
    DxListModule,  
    DxLoadPanelModule,
    DxToastModule,
    DxScrollViewModule
  } from 'devextreme-angular';
  
  import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-global-loader',
    template: `
     
        <dx-load-panel #loadPanel [visible]="loaderVisible()" [showIndicator]="true" [hideOnOutsideClick]="false">
        </dx-load-panel>

    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        DxDataGridModule,
        DxButtonModule,
        DxFormModule,
        DxMenuModule,
        DxToolbarModule,
        DxTabPanelModule,
        DxRadioGroupModule,
        DxDrawerModule,
        DxListModule,
        DxLoadPanelModule,
        DxToastModule,
        DxScrollViewModule,
    ]
})

export class AppLoaderComponent implements OnInit, AfterContentInit {


    constructor(
        private globals: AppGlobals
    ) { }

    ngOnInit(): void {

    }

    ngAfterContentInit(): void {

    }

    loaderVisible(): boolean {
        return   AppGlobals.GlobalLoaderVisible;
    }

}
